import moment from 'moment' 
import axios from 'axios' 
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
 
export default {
  extends: Bar,
  mixins: [reactiveProp],
  //props: [  "options", 'labels', 'height', 'color', 'xdisplay', 'ydisplay', 'gradient', 'symbol',  ],
    props:{
        chartData:{ type : [Array, Object] },
        chartDataName: { type: [String], default: '' },
        labels:{ type : [Array, Object] },
        height:{ type : [Number] },
        color:{ type : [String] },
        symbol:{ type : [String] },
        chartOptions: { 
            type: [Object], 
            default: ()=>{
                return {
                    maxTicksLimit: 24,
                    yAxesgridLines: true
                }
            }
        },
    },
    data () {
        return {
            chart: false,
        }
    },
    chartData: function() {
      return this.chartData;
    },
    watch: {
        'chartData':{
            deep: true,              
            handler() {
                console.log("watcher")
                console.log(this.chartData)
                //this._chart.update();
                this.init( this.labels, this.chartData )
            }
                
        }
    },
    methods:{
        init( columns, series ){
            
            //console.log("series")
            //console.log(series)
            //console.log( this.chartOptions )
            
            let symbol = this.symbol
      
            var color, gradient;

            if( this.color == undefined ){
                color = 'rgba(62, 70, 179, 1)';
                gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, this.height)
                gradient.addColorStop(0, 'rgba(62, 70, 179, 0.3)')
                gradient.addColorStop(0.8, 'rgba(62, 70, 179, 0)');
            }else{
                color = '#'+this.color;
                gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, this.height)
                gradient.addColorStop(0, 'rgba(255, 255, 255, 0.3)')
                gradient.addColorStop(0.8, 'rgba(255, 255, 255, 0)');
            }

            if( this.gradient == 'none' ){
                gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, this.height)
                gradient.addColorStop(0, 'rgba(255, 255, 255, 0)')
                gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
            }

            let datasets = [
                {
                    borderColor: '#3d6ad2',
                    backgroundColor: '#3d6ad2',
                    label: this.chartDataName,
                    data: series,
                    borderRadius: 15,
                },
                {
                    borderColor: '#ff0000',
                    backgroundColor: '#ff0000',
                    label: this.chartDataName,
                    data: series,
                    borderRadius: 15,
                }
            ]
            
            series.forEach((serie)=>{
                //serie.borderColor = "#ffffff"
                //serie.borderWidth = 2
                serie.borderRadius = 20
            })
            
            datasets = series
            console.log( datasets )
            
            let chartData = { labels: columns, datasets: datasets }

            //console.log( this.options )
            let options = {
                responsive: true, 
                interaction: {
                  mode: 'index',
                  intersect: false,
                },
                maintainAspectRatio: false, 
                
                legend: {
                    display: false,
                    position: "top",
                    align: 'end',
                    fullWidth: false,
                    labels: {
                        boxWidth: 10,
                        fillStyle: "Color",
                        fontSize: 11
                    },
                    //onClick: this.toggleLegend,
                }, 
                //onClick: this.handleClick,
                scales: {
                  xAxes: [{
                    stacked: true,
                    gridLines: {
                        display: false,
                        drawBorder: true,
                        color: '#f4f4f4'
                        //offsetGridLines : true
                    }, 
                    ticks: {
                        fontColor: '#000',
                        autoSkip: true,
                        maxTicksLimit: this.chartOptions.maxTicksLimit, // chartOptions.maxTicksLimit // 24
                        maxRotation: 0,
                        minRotation: 0,
                        //spadding: -25,
                        mirror:true,
                        callback: function(value, index, values) {
                            //console.log( value )
                            if( value.length == 10 ){
                               //return moment( value ).format( 'MMM D' ) 
                            }else{
                                //return moment( value ).format( 'HH' )
                            }
                            
                        }
                    },
                  }],

                  yAxes: [{
                    stacked: true,
                    gridLines: {
                        //display: this.chartOptions.yAxesgridLines, //yAxesgridLines
                        display: false,
                        color: '#f4f4f4'
                    },  
                    ticks: {
                        display: this.chartOptions.yAxesgridLines,
                        fontColor: '#697386',
                        beginAtZero: true,
                        callback: function(value, index, values) {
                            //return value
                            
                            //formatted
                            var SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"];

                            let number = value
                            // what tier? (determines SI symbol)
                            var tier = Math.log10(Math.abs(number)) / 3 | 0;

                            // if zero, we don't need a suffix
                            if(tier == 0) return number;

                            // get suffix and determine scale
                            var suffix = SI_SYMBOL[tier];
                            var scale = Math.pow(10, tier * 3);

                            // scale the number
                            var scaled = number / scale;

                            // format number and add suffix
                            return scaled.toFixed(0) + suffix;
                            //formatted
                        }
                    }, 
                  }],
                },
                tooltips: {

                    mode: 'index',
                    intersect: false,
                    displayColors: false,
                    /*
                    callbacks: {
                        title: function(tooltipItem, data) {

                            console.log( data['labels'][tooltipItem[0]['index']] )
                            //return moment( data['labels'][tooltipItem[0]['index']] ).format( 'HH:00' )
                            return data['labels'][tooltipItem[0]['index']]
                        },
                        label: function(tooltipItem, data) {
                            //console.log(data)
                            //console.log( data['datasets'][0]['data'][tooltipItem['index']] )
                            let series1 =  data['datasets'][0]['data'][tooltipItem['index']];
                            let result = symbol+' '+series1
                            
                            if( data['datasets'].length == 2 ){
                                let series2 =  data['datasets'][1]['data'][tooltipItem['index']];
                                //result += ' Today vs ' + symbol+' '+series2 + ' Yesterday'
                            }
                            
                            //result = result.toString()

                            return result
                        },
                        afterLabel: function(tooltipItem, data) {
                            var dataset = data['datasets'][0];
                            //console.log(dataset)
                            //var percent = Math.round((dataset['data'][tooltipItem['index']] / dataset["_meta"][0]['total']) * 100)
                            //return '(' + percent + '%)';
                        }
                    },
                    */
                    
                    callbacks: {
                        
                        label: function (t, d) {
        
                            //console.log( d.datasets )
                            //console.log( d.datasets.length )
                            let day = '';
                            let CVR = ''
                            if( d.datasets.length > 0 ){
                                
                                let day_label = d.datasets[t.datasetIndex].label
                                //console.log( day_label )
                                if( day_label != "" ){
                                    day = day_label + ": " 
                                }
                                
                            }
                            
                            //console.log( t.yLabel )
                            let formattedValue = t.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                                        
                            return day + " " + symbol + formattedValue
                            
                        },
                        footer: function(tooltipItems, data) {
                            var sum = 0;

                            tooltipItems.forEach(function(tooltipItem) {
                                //console.log( tooltipItem )
                                //console.log( data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] )
                                sum += data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                            });
                            
                            if( tooltipItems.length == 2 ){
                                //Conversion Rate = Total number of conversions / Total number of leads * 100
                                //let CVR = parseFloat( tooltipItems[1].value ) / parseFloat( tooltipItems[0].value ) * 100
                                //return 'CVR: ' + CVR.toFixed(2) + "%";
                            }
                            
                        }
                        
                    },
                    //custom: this.customTooltips,

                },
                layout: {
                    padding: { top: 10 }
                }

            }
            
            this.chart = this.renderChart( chartData, options )

            
        },
        
        toggleLegend( event, legendItem ){
            
            console.log(this._data._chart)
            console.log(legendItem)
            this.charData.datasets[legendItem.datasetIndex].hidden = legendItem.hidden
            this._data._chart.getDatasetMeta(1).hidden=true;
            this._data._chart.update();
            
        },
        
        handleClick (event, datasets) {
            //console.log(this)
            //console.log(datasets)
            //console.log(event)
 
            // Here is how to access the chart
            const c = this._data._chart;
            const datapoint = c.getElementAtEvent(event)[0];
            const indexBar = datapoint._index;
            const indexSegment = datapoint._datasetIndex;
            // Do whatever with this.my_data, indexBar, and indexSegment
            //console.log(indexBar)
            //console.log(indexSegment)
            
            //let index = datasets[indexSegment]._index
            let dataset = datasets[indexSegment]._chart.data.datasets[indexSegment].label
            let day = this.labels[indexBar]
            //console.log( day )
            //console.log( dataset )
                        
            this.$parent.get_list( day, dataset )
            
            /*
            const item = event[0]
            this.$emit('on-receive', {
                index: item._index,
                backgroundColor: item._view.backgroundColor,
                value: this.values[item._index]
              })
            */
            
            
        },
        
        customTooltips(tooltip) {
            // Tooltip Element
              let tooltipEl = document.getElementById('chartjs-tooltip');

              if(!tooltipEl) {
                tooltipEl = document.createElement('div');
                tooltipEl.id = 'chartjs-tooltip';
                tooltipEl.innerHTML = '<table></table>';
                this._chart.canvas.parentNode.appendChild(tooltipEl);
              }

              // Hide if no tooltip
              if(tooltip.opacity === 0) {
                tooltipEl.style.opacity = 0;
                return;
              }

              // Set caret Position
              tooltipEl.classList.remove('above', 'below', 'no-transform');
              if(tooltip.yAlign) {
                tooltipEl.classList.add(tooltip.yAlign);
              }
              else {
                tooltipEl.classList.add('no-transform');
              }
              function getBody(bodyItem) {
                return bodyItem.lines;
              }

              // Set Text
              if(tooltip.body) {
                const titleLines = tooltip.title || [];
                const bodyLines = tooltip.body.map(getBody);
                let innerHtml = '<thead>';

                titleLines.forEach(function(title) {
                  innerHtml += '<tr><th>' + title + '</th></tr>';
                });
                innerHtml += '</thead><tbody>';
                bodyLines.forEach(function(body, i) {
                  const colors = tooltip.labelColors[i];
                  let style = 'background:' + colors.backgroundColor;

                  style += '; border-color:' + colors.borderColor;
                  style += '; border-width: 2px';
                  const span = '<span class="chartjs-tooltip-key" style="' + style + '"></span>';

                  innerHtml += '<tr><td>' + span + body + '</td></tr>';
                });
                innerHtml += '</tbody>';
                const tableRoot = tooltipEl.querySelector('table');

                tableRoot.innerHTML = innerHtml;
              }
              const positionY = this._chart.canvas.offsetTop;
              const positionX = this._chart.canvas.offsetLeft;

              // Display, position, and set styles for font

              tooltipEl.style.opacity = 1;
              tooltipEl.style.left = positionX + tooltip.caretX + 'px';
              tooltipEl.style.top = positionY + tooltip.caretY + 'px';
              tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
              tooltipEl.style.fontSize = tooltip.bodyFontSize + 'px';
              tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
              tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
            },
        
        get_data( date ){
            
            let searchPhrase = '' 
            if( searchPhrase.includes( 'https://' ) ){
                searchPhrase = searchPhrase.replace('https://','')
            }
            
            axios({ 
                method: 'post',
                url: 'https://sql.theatlass.com/api/stats.php?s='+searchPhrase,
                headers: { 
                    'Access-Control-Allow-Headers': '*', 
                    'Access-Control-Allow-Origin': '*',  
                    'Content-Type': 'application/json;' 
                },
                data: { 
                    "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                    "startDate":  moment.utc(this.period[0]).format('YYYY-MM-DD'),
                    "endDate":  moment.utc(this.period[1]).add(1, 'day').format('YYYY-MM-DD'),
                    "searchPhrase": searchPhrase,
                    //"filters":  { key: "email", operator: "!=", value: "" }
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.status == 200 ){
                    let response_data = resp.data.data.results
                                      
                    //console.log(data)
                    //PROCESS DATA
                    //data.data = response_data
                    data.data = []
                    
                    if( data.type == 'A' ){
                        this.CHART_COLUMNS = []
                        this.CHART_SERIES = []
                    }else{
                        this.CHART_SERIES_COMPARE = []
                    }
                    
                    response_data.forEach((d)=>{
                        data.data.push( d )
                        if( data.type == 'A' ){
                            this.CHART_COLUMNS.push( d.day )
                            this.CHART_SERIES.push( d.count )
                        }else{
                            this.CHART_SERIES_COMPARE.push( d.count )
                        }
                            
                    })
                    
                    this.chartLoaded = true

                }else{
                    console.log("")
                }                
            })
            .then(function(){
                
                //this.rows.push( data )
                this.loaded = true;
                
            }.bind(this))
            
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error while fetching sources. Please reach out to us!'
                })

            }); //end axios 
            
        }
        
    },
  mounted () {
      
      this.init( this.labels, this.chartData )
      
  },

}



// WEBPACK FOOTER //
// ./src/components/charts/barChart_full.js